<template>
  <div
    v-if="!error"
    class="rounded-lg border border-alto-300 mt-12 mx-1 w-full max-w-sm mx-auto"
  >
    <nuxt-img src="images/happy-box-ellipse.png" class="w-full rounded-t-lg [clip-path:ellipse(100%_85%_at_50%_0%)]" />

    <div class="mb-5 -mt-5">
      <h1
        class="text-cerise-red-600 my-3 lg:text-base xl:text-xl font-bold text-center"
      >
        Una sorpresa gratuita ti aspetta!
      </h1>
      <div class="flex items-center gap-5 justify-center mb-3">
        <nuxt-img src="images/happy-box-logo.png" width="69px" height="87px" />
        <h2 class="font-bold lg:text-sm xl:text-base">
          Richiedi subito <br />
          Happy Box
        </h2>
      </div>
      <a
        target="_blank"
        href="https://happybox.prenatal.com/?utm_source=prenatal&utm_medium=sito&utm_campaign=area-loyalty"
        class="flex justify-center items-center"
      >
        <CoreButton>
          <div class="lg:text-sm xl:text-base">RICHIEDILA, È GRATIS!</div>
        </CoreButton>
      </a>
    </div>
  </div>
</template>

<script setup>
import { useProfile } from "~/store/profile";

const profileStore = useProfile();
await profileStore.getProfile();

const email = ref(profileStore.profile.email);

const error = ref("");
const loading = ref(false);

async function verifyEmail() {
  loading.value = true;

  try {
    const response = await $fetch("/api/verify-email", {
      method: "post",
      body: { email: email.value },
    });

    loading.value = false;
    error.value = "";

    // set cookie with 30 minutes expiration time
    const emailCookie = useCookie("email", {
      expires: new Date(Date.now() + 30 * 60000),
    });
    emailCookie.value = email.value;

    if (response.user_id) {
      const userIdCookie = useCookie("user_id", {
        expires: new Date(Date.now() + 30 * 60000),
      });
      userIdCookie.value = response.user_id;
    }
  } catch (err) {
    loading.value = false;
    error.value =
      err?.response?._data?.message ?? "È successo qualcosa, riprova più tardi";
  }
}

await verifyEmail();
</script>
